import React, { FC } from 'react';
import ProgressBar from 'components/ProgressBar';
import testingVar from 'utils/testingVar';
import keysOf from 'utils/keysOf';
import { Props } from './types';
import { Container } from './styles';
import { List, Item, ResultsLabel, Progress } from '../styles';

const PollResults: FC<Props> = ({ poll }) => {
  if (!poll) return null;
  return (
    <Container data-test-id={testingVar('poll-results')}>
      <List>
        {keysOf(poll).map((result) => (
          <Item key={result}>
            <ResultsLabel>
              {result}
              <Progress>
                {poll[result].percentage}% ({poll[result].count})
              </Progress>
            </ResultsLabel>
            <ProgressBar progress={poll[result].percentage} />
          </Item>
        ))}
      </List>
    </Container>
  );
};

export default PollResults;
